import { Helmet } from 'react-helmet';
import Simdata5gDetail
  from 'src/components/simdata5g-detail/Simdata5gDetail';

import {
  Box,
  Container,
} from '@material-ui/core';

import Simdata5gListToolbar from '../components/simdata5g-detail/Simdata5gToolbar';

const Simdata5g = () => (
  <>
    <Helmet>
      <title>Quản lý sim data 5G</title>
    </Helmet>
    <Box
      sx={{
        backgroundColor: 'background.default',
        minHeight: '100%',
        py: 3
      }}
    >
      <Container style={{maxWidth: "100%"}}>
        <Simdata5gListToolbar />
        <Box sx={{ pt: 3 }}>
          <Simdata5gDetail />
        </Box>
      </Container>
    </Box>
  </>
);

export default Simdata5g;
